import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Role } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  role: Identifiable<Role>;
  retrievePlanzoneRole(
    request: Boundaries["retrievePlanzoneRole"]["request"],
  ): void;
}

function useRetrievePlanzoneRole(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrievePlanzoneRoleRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrievePlanzoneRoleRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrievePlanzoneRoleRequestFailure,
    ),
    role: useSelector(selector.getPlanzoneRole),
    retrievePlanzoneRole: core.retrievePlanzoneRole,
  };
}

export { useRetrievePlanzoneRole };
